// import { useEffect, useState } from "react";
// import css from "./info.module.css";
// import srvd from "../../img/aboutPic.png"; // якщо треба картинка зверху — залиш
// import { doc, onSnapshot } from "firebase/firestore";
// import { db } from "../../firebase"; // ⚠️ відкоригуй шлях до свого firebase init

// export default function PublicOffer() {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const ref = doc(db, "pages", "publicOffer");
//     const unsub = onSnapshot(
//       ref,
//       (snap) => {
//         setData(snap.exists() ? snap.data() : null);
//         setLoading(false);
//       },
//       () => setLoading(false)
//     );
//     return () => unsub();
//   }, []);

//   if (loading) {
//     return (
//       <div className={css.aboutWrapAll}>
//         <div className={css.smallWrapAbout}>Завантаження…</div>
//       </div>
//     );
//   }

//   const navLinks = data?.navLinks ?? [];
//   const sections = data?.sections ?? [];

//   return (
//     <div className={css.aboutWrapAll}>
//       <div className={css.smallWrapAbout}>
//         {/* верхні кнопки/посилання — зберігаємо твої стилі */}
//         <h1 className={css.aboutCompanyH1}>
//           {navLinks.map((link, i) => {
//             const external =
//               typeof link.href === "string" && /^https?:\/\//i.test(link.href);
//             return (
//               <a
//                 key={i}
//                 className={css.aboutCompanyH1}
//                 href={link.href || "#"}
//                 {...(external
//                   ? { target: "_blank", rel: "noopener noreferrer" }
//                   : {})}
//               >
//                 {link.label}
//               </a>
//             );
//           })}
//         </h1>

//         <div className={css.wpaPicAbout}>
//           {/* Якщо хочеш показувати зображення: розкоментуй */}
//           {/* <img src={srvd} alt="" /> */}
//         </div>

//         {/* секції з HTML — стилі залишаються з класом paragInWrapBig */}
//         {sections.length === 0 ? (
//           <div className={css.paragInWrapBig}>
//             Контент цієї сторінки ще не додано. Зайди в адмінку та збережи дані.
//           </div>
//         ) : (
//           sections.map((s) => (
//             <section key={s.id} id={s.id}>
//               {/* прихований h2 — для доступності/SEO, верстку не ламає */}
//               {s.title ? <h2 style={{ display: "none" }}>{s.title}</h2> : null}
//               <div
//                 className={css.paragInWrapBig}
//                 dangerouslySetInnerHTML={{ __html: s.contentHtml || "" }}
//               />
//             </section>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }
// src/components/PublicOffer.jsx
import { useEffect, useState } from "react";
import css from "./info.module.css";
// Якщо справді показуєш картинку зверху — розкоментуй рядок нижче і <img> в JSX
// import srvd from "../../img/aboutPic.png";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

// Потрібно для класів типу ql-align-*, ql-indent-* тощо
import "react-quill/dist/quill.core.css";

// Універсальний відображувач Quill-HTML
function QuillView({ html = "", className = "" }) {
  return (
    <div
      className={`${className} ql-editor`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default function PublicOffer() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, "pages", "publicOffer");
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setData(snap.exists() ? snap.data() : null);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div className={css.aboutWrapAll}>
        <div className={css.smallWrapAbout}>Завантаження…</div>
      </div>
    );
  }

  const navLinks = data?.navLinks ?? [];
  const sections = data?.sections ?? [];

  return (
    <div className={css.aboutWrapAll}>
      <div className={css.smallWrapAbout}>
        {/* верхні кнопки/посилання — залишаю структуру як у твоєму прикладі */}
        <h1 className={css.wrapAllK}>
          {navLinks.map((link, i) => {
            const external =
              typeof link.href === "string" && /^https?:\/\//i.test(link.href);
            return (
              <a
                key={i}
                className={css.aboutCompanyH1}
                href={link.href || "#"}
                {...(external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                {link.label}
              </a>
            );
          })}
        </h1>

        <div className={css.wpaPicAbout}>
          {/* Якщо хочеш показувати зображення: розкоментуй */}
          {/* <img src={srvd} alt="" /> */}
        </div>

        {/* Секції — тепер через QuillView з класом ql-editor */}
        {sections.length === 0 ? (
          <div className={css.paragInWrapBig}>
            Контент цієї сторінки ще не додано. Зайди в адмінку та збережи дані.
          </div>
        ) : (
          sections.map((s) => (
            <section key={s.id} id={s.id}>
              {/* прихований h2 — для доступності/SEO */}
              {s.title ? <h2 style={{ display: "none" }}>{s.title}</h2> : null}
              <QuillView
                className={css.paragInWrapBig}
                html={s.contentHtml || ""}
              />
            </section>
          ))
        )}
      </div>
    </div>
  );
}
